<div class="list-wrapper">
  <div class="list-heading row">
    <div class="list-heading-data row">
      <div class="col-1">
        {{ 'ADMIN.SHARED.ID' | translate }}
      </div>
      <div class="col-3">
        {{ 'ADMIN.CLIENT_USERS.SOLDTO' | translate }}
      </div>
      <div class="col-5">
        {{ 'ADMIN.CLIENT_USERS.SHIPTOS' | translate }}
      </div>
      <div class="col-3">
        {{ 'ADMIN.CLIENT_USERS.ROLE' | translate }}
      </div>
    </div>
    <div class="action_buttons"></div>
  </div>
  <div class="list-body">
    <div
      class="list-item row"
      *ngFor="let customerRole of selectedSoldTosAndShipTos"
    >
      <form
        [formGroup]="editCustomerForm"
        *ngIf="editCustomerForm && customerRole.isEdit"
        class="list-item-form col-md-11 form-row"
      >
        <div class="list-item-data row">
          <div class="col-12 list-item-heading">
            {{ 'ADMIN.SHARED.ID' | translate }}
          </div>
          <span class="col-md-1 col-sm-12">
            {{ customerRole.soldTo?.id }}
          </span>
          <div class="col-12 list-item-heading">
            {{ 'ADMIN.CLIENT_USERS.SOLDTO' | translate }}
          </div>
          <span class="col-md-3 col-sm-12">
            {{ customerRole.soldTo?.name }}
          </span>
          <div class="col-12 list-item-heading">
            {{ 'ADMIN.CLIENT_USERS.SHIPTOS' | translate }}
          </div>
          <span class="col-md-5 col-sm-12">
            <eps-select
              #shipTo
              [options]="shipTos"
              [labelsDisplayed]="1"
              [disabled]="loading"
              [busy]="loadingShipTos"
              [clearable]="false"
              formControlName="shipToIds"
              labelPosition="none"
              required
              multiple
            ></eps-select>
          </span>
          <div class="col-12 list-item-heading">
            {{ 'ADMIN.CLIENT_USERS.ROLE' | translate }}
          </div>
          <div class="col-md-3 col-sm-12">
            <eps-select
              [options]="roles"
              [disabled]="loading"
              [clearable]="false"
              formControlName="roleId"
              labelPosition="none"
              required
            ></eps-select>
          </div>
        </div>
      </form>
      <div
        class="list-item-data row"
        *ngIf="!customerRole.isEdit"
      >
        <div class="col-12 list-item-heading">
          {{ 'ADMIN.SHARED.ID' | translate }}
        </div>
        <span class="col-md-1 col-sm-12">
          {{ customerRole.soldTo?.id }}
        </span>
        <div class="col-12 list-item-heading">
          {{ 'ADMIN.CLIENT_USERS.SOLDTO' | translate }}
        </div>
        <span class="col-md-3 col-sm-12">
          {{ customerRole.soldTo?.name }}
        </span>
        <div class="col-12 list-item-heading">
          {{ 'ADMIN.CLIENT_USERS.SHIPTOS' | translate }}
        </div>
        <span class="col-md-5 col-sm-12">
          <span *ngIf="customerRole.shipToNames">
            {{ customerRole.shipToNames }}
          </span>
          <span *ngIf="!customerRole.shipToNames">
            {{ 'ADMIN.CLIENT_USERS.ALL_SHIPTOS' | translate }}
          </span>
        </span>
        <div class="col-3 list-item-heading">
          {{ 'ADMIN.CLIENT_USERS.ROLE' | translate }}
        </div>
        <div class="col-md-3 col-sm-12">
          <span>{{ (customerRole.role ? 'ADMIN.ROLES.' + customerRole.role.id : '') | translate }}</span>
        </div>
      </div>
      <div
        class="list-item-action_buttons col-md-1"
        *ngIf="!readonly"
      >
        <a
          mat-button
          class="no_decoration action_button"
          [disabled]="!editCustomerForm.valid"
          (click)="editCustomerForm.valid && saveCustomer()"
          *ngIf="customerRole.isEdit"
        >
          <i class="fa fa-save"></i>
        </a>
        <a
          mat-button
          class="no_decoration action_button"
          (click)="cancelEditCustomer(customerRole)"
          *ngIf="customerRole.isEdit"
        >
          <i class="fa fa-undo"></i>
        </a>
        <a
          mat-button
          class="no_decoration action_button"
          [disabled]="showNewLine"
          (click)="!showNewLine && !customerRole.isEdit && editCustomer(customerRole)"
          *ngIf="canEditLine"
        >
          <i class="fa fa-pencil"></i>
        </a>
        <a
          mat-button
          class="no_decoration action_button"
          [disabled]="showNewLine"
          (click)="!showNewLine && !customerRole.isEdit && removeCustomer(customerRole)"
          *ngIf="canEditLine"
        >
          <i class="fa fa-times-circle-o"></i>
        </a>
      </div>
    </div>

    <div
      *ngIf="selectedSoldTosAndShipTos.length === 0"
      class="list-item"
    >
      {{ 'ADMIN.CLIENT_USERS.NO_CUSTOMER_ROLE_MAPPINGS' | translate }}
    </div>

    <div
      class="add-header"
      *ngIf="showNewLine && !readonly"
    >
      <form
        class="newCustomerForm"
        [formGroup]="newCustomerForm"
      >
        <div class="row label-header">
          <div class="col-11">
            <div class="row">
              <div class="col-2">
                <app-label translationCode="ADMIN.CLIENT_USERS.SALES_ORG"></app-label>
              </div>
              <div class="col-3">
                <app-label translationCode="ADMIN.CLIENT_USERS.SOLDTO"></app-label>
              </div>
              <div class="col-4">
                <app-label translationCode="ADMIN.CLIENT_USERS.SHIPTOS"></app-label>
              </div>
              <div class="col-3">
                <app-label translationCode="ADMIN.CLIENT_USERS.ROLE"></app-label>
              </div>
            </div>
            <div class="col-1"></div>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="row">
          <div class="col-md-11 col-sm-12">
            <div class="row">
              <div class="col-md-2 col-sm-12 item-add-content">
                <eps-select
                  [options]="salesOrganizationsToDisplay"
                  formControlName="salesOrganisationId"
                  [disabled]="loading"
                  (ngModelChange)="salesOrganisationSelected()"
                  label="ADMIN.CLIENT_USERS.SALES_ORG"
                  [labelPosition]="(fieldsInColumn$ | async) ? 'top' : 'none'"
                  hideOptionalMarker
                  required
                ></eps-select>
              </div>

              <div class="col-md-3 col-sm-12 item-add-content">
                <eps-select
                  [options]="availableSoldTos"
                  formControlName="soldToId"
                  (ngModelChange)="soldToSelected()"
                  [disabled]="loading"
                  [busy]="loadingSoldTos"
                  [clearable]="false"
                  label="ADMIN.CLIENT_USERS.SOLDTO"
                  [labelPosition]="(fieldsInColumn$ | async) ? 'top' : 'none'"
                  hideOptionalMarker
                  required
                ></eps-select>
              </div>

              <div class="col-md-4 col-sm-12 item-add-content">
                <eps-select
                  #shipTo
                  [options]="shipTos"
                  [labelsDisplayed]="1"
                  [disabled]="loading"
                  [busy]="loadingShipTos"
                  [clearable]="false"
                  label="ADMIN.CLIENT_USERS.SHIPTOS"
                  formControlName="shipToIds"
                  [labelPosition]="(fieldsInColumn$ | async) ? 'top' : 'none'"
                  hideOptionalMarker
                  required
                  multiple
                ></eps-select>
              </div>

              <div class="col-md-3 col-sm-12 item-add-content">
                <eps-select
                  [options]="roles || []"
                  [disabled]="loading"
                  [clearable]="false"
                  formControlName="roleId"
                  label="ADMIN.CLIENT_USERS.ROLE"
                  [labelPosition]="(fieldsInColumn$ | async) ? 'top' : 'none'"
                  hideOptionalMarker
                  required
                ></eps-select>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-sm-12 new-role-buttons">
            <a
              mat-button
              class="no_decoration action_button"
              (click)="newCustomerForm.valid && addCustomer()"
              [disabled]="!newCustomerForm.valid"
            >
              <i class="fa fa-plus-circle"></i>
            </a>
            <a
              mat-button
              class="no_decoration action_button"
              (click)="cancelAddCustomer()"
            >
              <i class="fa fa-times-circle-o"></i>
            </a>
          </div>
        </div>
      </form>
    </div>
    <div
      class="list-add_item_wrapper"
      *ngIf="!readonly && canEditLine && !showNewLine && (!maxRoles || selectedSoldTosAndShipTos.length < maxRoles)"
    >
      <span
        class="list-add_item"
        (click)="startAddCustomer()"
      >
        <i class="fa fa-plus"></i> {{ 'ADMIN.CLIENT_USERS.ADD_CUSTOMER' | translate }}
      </span>
    </div>
  </div>
</div>
